var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChatLine = function SvgChatLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 682 682"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M551.451-1.043H87.882C39.413-1.043-.02 38.383-.02 86.859v283.695c0 48.366 39.262 87.73 87.59 87.902v128.737l185.01-128.736h278.871c48.469 0 87.902-39.435 87.902-87.902V86.859c.001-48.476-39.433-87.902-87.902-87.902zm50.44 371.597c0 27.809-22.626 50.438-50.439 50.438H260.826l-135.793 94.494v-94.494H87.882c-27.813 0-50.439-22.63-50.439-50.438V86.859c0-27.817 22.627-50.439 50.439-50.439h463.569c27.813 0 50.439 22.622 50.439 50.439v283.695z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.105 131.331h297.124v37.464H171.105v-37.464zm0 79.922h297.124v37.464H171.105v-37.464zm0 79.922h297.124v37.464H171.105v-37.464z"
  })));
};

export default SvgChatLine;